import { render, staticRenderFns } from "./sjxx_detail.vue?vue&type=template&id=5a0a3d41&"
import script from "./sjxx_detail.vue?vue&type=script&lang=js&"
export * from "./sjxx_detail.vue?vue&type=script&lang=js&"
import style0 from "./sjxx_detail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports